module.exports = __webpack_public_path__ + "static/media/events-card-image.716e621f.png";